module.exports = __webpack_public_path__ + "static/media/basket_icon.703869c5.png";